import { ImagesCarousel } from '@ubeya/shared-web/components';
import React, { useState } from 'react';
import styled from 'styled-components';

const Photos = styled.div`
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  margin-bottom: 20px;
`;

const Photo = styled.img`
  width: 74px;
  height: 74px;
  cursor: pointer;
  border-radius: 12px;
  object-fit: cover;
  object-position: 50% 50%;
`;

export const PhotoGallery = ({ photos = [], avatar, setIsPhotoGalleryOpen }) => {
  const [openIndex, setOpenIndex] = useState();

  setIsPhotoGalleryOpen(openIndex !== undefined);
  const galleryPhotos = avatar ? [{ link: avatar }, ...photos] : photos;

  if (!photos.length) {
    return null;
  }

  return (
    <>
      <Photos>
        {photos.map(({ link }, index) => (
          <Photo src={link} key={index} onClick={() => setOpenIndex(avatar ? index + 1 : index)} />
        ))}
      </Photos>
      <ImagesCarousel
        views={galleryPhotos.map((photo) => ({ source: photo.link }))}
        currentIndex={openIndex}
        onClose={() => setOpenIndex()}
      />
    </>
  );
};
